import Vue, { CreateElement } from 'vue';
import { VueConstructor } from 'vue/types/vue';
import VueCompositionApi from '@vue/composition-api';
import * as commonSDK from 'hybrid-sdk-common';
import VueLazyload from 'vue-lazyload';
import HTTP from '../api/http';
import logger from '@k/logger';
import dirLogger from '@d/logger';
import { getAppInfo } from '@k/system';
import '@a/base.less';
import { asyncJSLoader } from '@k/common';
import urlExt from '@k/url';
// @ts-ignore xxx
import { zsH5Setup } from '@k/zs';
// @ts-ignore xxx
import { zs } from '@zyb-data/stats-h5';
import VueObserveVisibility from 'vue-observe-visibility';
import 'core-js/stable';

const hybrid = commonSDK.hybrid;

interface PageOptions {
  routes: any[];
  entry?: string;
  data?: { [key: string]: unknown };
  beforeInitial?(V: VueConstructor): void;
}

class Page {
  private instanceOptions: { [index: string]: any } = {}; // eslint-disable-line

  constructor(private options: PageOptions) {
    this.init();
  }

  async initVconsole(): Promise<void> {
    const appInfo = await getAppInfo(hybrid);
    return new Promise((resolve, reject) => {
      try {
        if (Number(urlExt.getQuery('debug')) === 1 || appInfo?.feconsole == 1 || /__vconsole__/.test(location.search)) {
          asyncJSLoader('https://static.kuaiduizuoye.com/product/FECommon/Js/vconsole.min.js', 'VConsole', () => {
            new VConsole(); // eslint-disable-line
            resolve();
          });
        } else {
          resolve();
        }
      } catch (e) {
        reject(e);
      }
    });
  }

  async init(): Promise<void> {
    await this.initVconsole();
    await this.commonInit();
    this.directiveInit();
    this.optionsInit();
    this.options.beforeInitial && this.options.beforeInitial(Vue);
    new Vue(this.instanceOptions).$mount('#app'); // eslint-disable-line
  }

  async commonInit(): Promise<void> {
    const appInfo = await getAppInfo(hybrid);
    Vue.use(VueCompositionApi);
    Vue.use(HTTP);
    Vue.use(VueLazyload);
    Vue.$cmn = Vue.prototype.$cmn = appInfo;
    Vue.logger = Vue.prototype.logger = logger;
    Vue.hybrid = Vue.prototype.hybrid = hybrid;
    Vue.use(VueObserveVisibility);
    // 初始化全埋点
    zsH5Setup(Vue, zs);
    Vue.setData = (key: string, value: any) => {
      // eslint-disable-line
      this.instanceOptions[key] = value;
    };
  }

  directiveInit(): void {
    Vue.directive('log', dirLogger.loggerPV);
    Vue.directive('log-click', dirLogger.loggerClick);
  }

  optionsInit(): void {
    const _ = { data: this.options.data || {} };
    // 路由只有一个不使用 vue-router
    const cur = this.options.routes[0];
    this.instanceOptions = {
      ..._,
      render: (h: CreateElement) => h('div', { attrs: { id: 'app' } }, [h((cur as any).component)]) // eslint-disable-line
    };
  }
}

export default Page;
